import React, { FC, MouseEvent } from 'react';
import { observer } from 'mobx-react';
import './chat-notifications.scss';
import { useStore } from '../../../store/store-provider';
import Notification from './notification/notification';

const ChatNotification: FC = (): JSX.Element => {
  const { chatStore: { notification, toggleChatBoxVisibility, closeNotificationPopup }} = useStore();

  const onClose = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    closeNotificationPopup();
  };

  return (
    <div className="notification-container" aria-hidden="true" role="button" tabIndex={0}>
      {notification && (
        <Notification
          notification={notification}
          onOpen={toggleChatBoxVisibility}
          onClose={(event) => onClose(event)}
        />
      )}
    </div>
  );
};

export default observer(ChatNotification);
